import uniqueId from 'lodash/uniqueId';

import { bodyScrollDisable, bodyScrollEnable } from './scrollHelpers';

export const disablers: Set<string> = new Set();

export interface IBodyScrollController {
  enable(): void;
  disable(): void;
}

export function createBodyScroll(): IBodyScrollController {
  const controllerId = uniqueId('bodyScroll');

  return {
    enable: () => bodyScrollEnable(controllerId),
    disable: () => bodyScrollDisable(controllerId),
  };
}
